import React, { Component, Fragment } from 'react';
//utils
import { Translations, convertStringToArrayForOption } from '../../../../utils';
//children
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';

export class SetItalyList extends React.Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  render() {
    const { data, staticData } = this.props;
    return (
      <div className="gdocs-mbottom-30">
        <dt>
          {data.accountSignatory.firstName !== undefined ? data.accountSignatory.firstName + " " : ""}
          {data.accountSignatory.lastName !== undefined ? data.accountSignatory.lastName + " " : ""}
          {data.accountSignatory.dateOfBirth !== undefined ? data.accountSignatory.dateOfBirth : ""}
        </dt>
        <dd>
        </dd>
        <dt>
          {this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[1]}
        </dt>
        <dd>
          {data.previouslySignedAccountSignatoryDeclarationForm !== undefined ? (data.previouslySignedAccountSignatoryDeclarationForm === true ? 'Yes' : 'No') : ""}
        </dd>
        {
          data.previouslySignedAccountSignatoryDeclarationForm !== undefined
            ? (data.previouslySignedAccountSignatoryDeclarationForm !== true
              ? <div>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[2]}</dt>
                <dd>{data.sex !== undefined ? data.sex : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[3]}</dt>
                <dd>{data.placeOfBirth !== undefined ? data.placeOfBirth : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[4]}</dt>
                <dd>
                  {'countryOfCitizenship' in data && data.countryOfCitizenship.name !== undefined ? data.countryOfCitizenship.name : ""}
                </dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[5]}</dt>
                <dd>
                  <b>
                    {data.address !== undefined && data.address.addressLine1 !== undefined ? data.address.addressLine1 + ', ' : ""}
                    {data.address !== undefined && data.address.addressLine2 !== undefined ? data.address.addressLine2 + ', ' : ""}
                    {data.address !== undefined && data.address.addressLine3 !== undefined ? data.address.addressLine3 + ', ' : ""}
                    {data.address !== undefined && data.address.city !== undefined ? data.address.city : ""}
                  </b>
                </dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[6]}</dt>
                <dd>{data.typeOfProvidedIdCard !== undefined ? data.typeOfProvidedIdCard : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[7]}</dt>
                <dd>{data.documentIdNumber !== undefined ? data.documentIdNumber : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[8]}</dt>
                <dd>{data.signDateOfIssue !== undefined ? data.signDateOfIssue : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[9]}</dt>
                <dd>{data.placeOfIssue !== undefined ? data.placeOfIssue : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[10]}</dt>
                <dd>{data.issuingAuthority !== undefined ? data.issuingAuthority : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[11]}</dt>
                <dd>{data.signExpirationDate !== undefined ? data.signExpirationDate : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[12]}</dt>
                <dd>{data.personalResidense !== undefined ? data.personalResidense : ""}</dd>
                <dt>{this.translateWord(staticData.dynamic_accordion_list_Italy.fieldLabels)[13]}</dt>
                <dd>{data.fiscalCode !== undefined ? data.fiscalCode : ""}</dd>
              </div>
              : '')
            : ""
        }

      </div>
    )
  }

}


class AdditionalData extends Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  render() {
    const { additionalDataRequired, pageJson } = this.props;
    const staticData = this.props.pageJson;
    /*=================================TabPanelContentBasicDetails start================*/
    const countryIndiaDecForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-content">
            <dl className="dl-horizontal">
              <dt>
                {this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[0]}
              </dt>
              <dd>
                <b>{childitem !== undefined && childitem.creditFacilityDescription !== undefined ? childitem.creditFacilityDescription === true ? 'Yes' : 'No' : ""}</b>
              </dd>
            </dl>
            <dl className="dl-horizontal gdoc-echannel-repeat">
              {
                (childitem !== undefined) && (childitem.bankDetails !== undefined && childitem.bankDetails.length > 0)
                  ? childitem.bankDetails.map((itemchild, key) => {
                    return (<Fragment key={key}>
                      <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]} {key + 1}</dt>
                      <dd><b>{itemchild != null && itemchild.bankName !== undefined ? itemchild.bankName : "Not Available"}</b></dd>
                      <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[2]} {key + 1}</dt>
                      <dd><b>{itemchild != null && itemchild.accountNumber !== undefined ? itemchild.accountNumber : "Not Available"}</b></dd>
                    </Fragment>);
                  })
                  : ""
              }
            </dl>
            <dl className="dl-horizontal">
              <dt>
                {this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[3]}
              </dt>
              <dd>
                <b>{childitem !== undefined && childitem.acceptForeignContribution !== undefined ? childitem.acceptForeignContribution === true ? 'Yes' : 'No' : ""}</b>
              </dd>
              <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[4]}</dt>
              <dd>
                <b>{childitem !== undefined && childitem.registeredOutsideIndia !== undefined ? childitem.registeredOutsideIndia === true ? 'Yes' : 'No' : ""}</b>
              </dd>
              {childitem.registeredOutsideIndia === true ?
                <Fragment>
                  <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[5]}</dt>
                  <dd>
                    <b>{childitem !== undefined && childitem.liaisonOffice !== undefined ? childitem.liaisonOffice === true ? 'Yes' : 'No' : ""}</b>
                  </dd>
                </Fragment>
                : null
              }
            </dl>
          </div>
        </div>
      );
    }

    const countryAustraliaForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-heading">{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[0]}</div>
          <div className="basic-detail-content">
            <div>
              <p>
                {this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]}
              </p>
              <dl className="dl-horizontal" >
                {childitem.authorisedRefreeForm !== undefined ? childitem.authorisedRefreeForm.map((ausData, key) => {
                  return (
                    <div className="" key={key}>
                      <dt>
                        {ausData.signatory !== undefined && ausData.signatory.firstName !== undefined ? ausData.signatory.firstName + " " : ""}
                        {ausData.signatory !== undefined && ausData.signatory.lastName !== undefined ? ausData.signatory.lastName + " " : ""}
                        {ausData.signatory !== undefined && ausData.signatory.dateOfBirth !== undefined ? ausData.signatory.dateOfBirth : ""}

                      </dt>
                      <dd>{ausData.signed === true ? 'Yes' : 'NO'}</dd>
                    </div>
                  )
                }) : ""}
              </dl>
              <dl className="dl-horizontal" >
                {childitem.authoriserSignatories !== undefined ? childitem.authoriserSignatories.map((ausData, key) => {
                  return (
                    <Fragment className="" key={key}>
                      <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[2]} {key + 1}</dt>
                      <dd>
                        {ausData !== undefined && ausData.firstName !== undefined ? ausData.firstName + " " : ""}
                        {ausData !== undefined && ausData.lastName !== undefined ? ausData.lastName + " " : ""}
                        {ausData !== undefined && ausData.telephoneCountryCode !== undefined ? ausData.telephoneCountryCode.name : ""}
                      </dd>
                    </Fragment>)
                }) : ""}
              </dl>
            </div>
          </div>
        </div>
      );
    }

    const RenderFranceDataList = (childitem, staticData) => {
      let status = childitem.communicationMedium.value

      switch (status) {
        case 'phone':
          return [
            <dt>{this.translateWord(staticData.dynamic_accordion_list_france.fieldLabels)[2]}</dt>,
            <dd>{childitem.phoneNumber}</dd>
          ];
        case 'fax':
          return [
            <dt>{this.translateWord(staticData.dynamic_accordion_list_france.fieldLabels)[3]}</dt>,
            <dd>{childitem.faxNumber}</dd>
          ];
        case 'mail':
          return [
            <dt>{this.translateWord(staticData.dynamic_accordion_list_france.fieldLabels)[4]}</dt>,
            <dd>
              <b>
                {childitem.address !== undefined && childitem.address.addressLine1 !== undefined
                  ? `${childitem.address.addressLine1},`
                  : ""
                }
                {
                  childitem.address !== undefined && childitem.address.addressLine2 !== undefined
                    ? `${childitem.address.addressLine2},`
                    : ""
                }
                {
                  childitem.address !== undefined && childitem.address.addressLine3 !== undefined
                    ? `${childitem.address.addressLine3},`
                    : ""
                }
                {
                  childitem.address !== undefined && childitem.address.city !== undefined
                    ? `${childitem.address.city},`
                    : ""
                }
                {
                  childitem.address !== undefined && childitem.address.state !== undefined
                    ? `${childitem.address.state},`
                    : ''
                }
                {
                  childitem.address !== undefined && childitem.address.country !== undefined && childitem.address.country.name !== undefined
                    ? `${childitem.address.country.name}`
                    : ''
                }
              </b>
            </dd>
          ];
        default:
          return '';
      }
    }

    const countryFranceForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-content">
            <dl className="dl-horizontal" >
              <dt>
                {this.translateWord(staticData.dynamic_accordion_list_france.fieldLabels)[1]}
              </dt>
              <dd>
                <b>{childitem.communicationMedium !== undefined && childitem.communicationMedium.name !== undefined ? childitem.communicationMedium.name : ""}</b>
              </dd>
              {
                childitem.communicationMedium !== undefined && childitem.communicationMedium.value !== undefined
                  ? RenderFranceDataList(childitem, staticData)
                  : ''
              }
            </dl>
          </div>
        </div>
      )
    }
    const countryPolandFormEchannel = (childitem, staticData) => {

      if (childitem !== undefined && childitem.hsbcAdditionalUser !== undefined) {
        const dataInLoop = (polandFormData, staticData, key) => {
          return (

            <div className="basic-detail-content" key={key}>
              <dl className="dl-horizontal" >
                <dt>
                  Additional user {key + 1}
                </dt>
                <dd>{polandFormData.signatory !== undefined && polandFormData.signatory.firstName === true ? polandFormData.signatory.firstName + " " : ""}
                  {polandFormData.signatory !== undefined && polandFormData.signatory.lastName === true ? polandFormData.signatory.lastName : ""}
                  <br></br>
                  {polandFormData.signatory !== undefined && polandFormData.signatory.dateOfBirth === true ? polandFormData.signatory.dateOfBirth : ""}</dd>
                <dt> Are you Polish resident? </dt>
                <dd>{polandFormData.polResident !== undefined && polandFormData.polResident === true ? "Yes" : "No"}</dd>
                <dt>Polish resident identification number</dt>
                <dd>{polandFormData.polResidentIdNumber !== undefined ? polandFormData.polResidentIdNumber : ""}</dd>
                <dt>ID Document number</dt>
                <dd>{polandFormData.polIdDocNumber !== undefined ? polandFormData.polIdDocNumber : ""}</dd>
                <dt>Issue date of ID Document</dt>
                <dd>{polandFormData.docIssueDate !== undefined ? polandFormData.docIssueDate : ""}</dd>
                <dt>Expiry date of ID Document</dt>
                <dd>{polandFormData.docExpiryDate !== undefined ? polandFormData.docExpiryDate : ""}</dd>
                <dt>Do you require system administrator privileges?</dt>
                <dd>{polandFormData.systemAdminPrivileges !== undefined && polandFormData.systemAdminPrivileges === true ? "Yes" : "No"}</dd>
              </dl>
            </div>

          )
        }

        return (
          <div className="basic-details-container">
            <div className="basic-detail-heading">{staticData.basicDetails}</div>
            {
              childitem.hsbcAdditionalUser.length > 0 ? childitem.hsbcAdditionalUser.map((polandFormData, key) => {
                return dataInLoop(polandFormData, staticData, key);
              }) : ""
            }
          </div>
        );

      } else {
        return (<div></div>);
      }
    }


    const countryCanadaForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-heading">{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[0]}</div>
          <div className="basic-detail-content">
            <p>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]}</p>
            <dl className="dl-horizontal" >
              {
                childitem.consentForm !== undefined ? childitem.consentForm.map((canadaData, key) => {

                  return (
                    <div key={key}>
                      <dt>
                        {canadaData.signatory !== undefined && canadaData.signatory.firstName !== undefined ? canadaData.signatory.firstName + " " : ""}
                        {canadaData.signatory !== undefined && canadaData.signatory.lastName !== undefined ? canadaData.signatory.lastName : ""}
                      </dt>
                      <dd>{canadaData.personalInfoConsent !== undefined && canadaData.personalInfoConsent === true ? "Yes" : "No"}</dd>
                    </div>);
                }) : ""
              }

            </dl>
          </div>
        </div>
      )
    }
    const countryCzechForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-heading">{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[0]}</div>
          <div className="basic-detail-content">
            <p>
              {this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]}
            </p>
            <dl className="dl-horizontal" >
              {childitem.authorisedRefreeForm !== undefined ? childitem.authorisedRefreeForm.map((data, key) => {
                return (
                  <Fragment key={key}>
                    <dt>
                      {data.signatory !== undefined && data.signatory.firstName !== undefined ? data.signatory.firstName + " " : ""}
                      {data.signatory !== undefined && data.signatory.lastName !== undefined ? data.signatory.lastName : ""}
                    </dt>
                    <dd>{data.previouslySignedAuthorisedRefereeForm !== undefined && data.previouslySignedAuthorisedRefereeForm === true ? "Yes" : "No"}</dd>
                  </Fragment>
                )

              }) : ""}

              {childitem.authoriserSignatories !== undefined ? childitem.authoriserSignatories.map((data, key) => {
                return (
                  <Fragment key={key}>
                    <dt>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[2]} {key + 1}</dt>
                    <dd>
                      {data.firstName !== undefined ? data.firstName + " " : ""}
                      {data.lastName !== undefined ? data.lastName + " " : ""}
                      <br></br>
                      {data.jobTitle !== undefined ? data.jobTitle + " " : ""}
                    </dd>
                  </Fragment>
                )
              }) : ""}

            </dl>
          </div>
        </div>
      )
    }

    const countrySingaporeForm = (childitem, staticData) => {
      return (<div>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]}</div>)
    }
    const countrySpainForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-heading"></div>
          <div className="basic-detail-content">
            <dl className="dl-horizontal" >
              <dt>{this.translateWord(staticData.dynamic_accordion_list_spain.fieldLabels)[1]}</dt>
              <dd>{childitem.countryOfTaxResidence !== undefined && childitem.countryOfTaxResidence.name !== undefined ? childitem.countryOfTaxResidence.name : ""}</dd>
              {
                childitem.taxSignatories !== undefined ? childitem.taxSignatories.map((data, key) => {
                  return (<Fragment key={key}>
                    <dt>{this.translateWord(staticData.dynamic_accordion_list_spain.fieldLabels)[2]} {key + 1}</dt>
                    <dd>
                      {data.firstName !== undefined ? data.firstName + " " : ""}
                      {data.lastName !== undefined ? data.lastName : ""}
                      <br></br>
                      {data.jobTitle !== undefined ? data.jobTitle : ""}
                    </dd>
                  </Fragment>)
                }) : ""
              }
            </dl>
          </div>
        </div>
      )
    }
    const countryUKDecForm = (childitem, staticData) => {
      return (<div>{this.translateWord(staticData.dynamic_accordion_list_india.fieldLabels)[1]}</div>)
    }
    const countryItalyForm = (childitem, staticData) => {
      return (
        <div className="basic-details-container">
          <div className="basic-detail-heading">{staticData.basicDetails}</div>
          <div className="basic-detail-content">
            <dl className="dl-horizontal" >
              {
                childitem.signatoryDeclaration !== undefined
                  ? childitem.signatoryDeclaration.map(italyData =>
                    <SetItalyList data={italyData} staticData={staticData}
                      translateWord={(word) => this.translateWord(word)}
                      lang={this.props.lang}
                    />)
                  : ''
              }
            </dl>
          </div>
        </div>
      )
    }



    const countryPolandFormGLS = (childitem, staticData) => {
      return (<div>countryPolandFormGLS</div>)
    }
    /*=================================TabPanelContentBasicDetails end==============================*/
    const additionalDataMethod = (childitem, staticData) => {
      const currentCase = (Object.keys(childitem))[4];

      switch (currentCase) {
        case "countryIndiaDecForm":
          return countryIndiaDecForm(childitem[currentCase], staticData);
          break;
        case "countryAustraliaForm":
          return countryAustraliaForm(childitem[currentCase], staticData);
          break;
        case "countryCanadaForm":
          return countryCanadaForm(childitem[currentCase], staticData);
          break;
        case "countryCzechForm":
          return countryCzechForm(childitem[currentCase], staticData);
          break;
        case "countryFranceForm":
          return countryFranceForm(childitem[currentCase], staticData);
          break;
        case "countryPolandFormEchannel":
          return countryPolandFormEchannel(childitem[currentCase], staticData);
          break;
        case "countryPolandFormGLS":
          return countryPolandFormGLS(childitem[currentCase], staticData);
          break;
        case "countrySingaporeForm":
          return countrySingaporeForm(childitem[currentCase], staticData);
          break;
        case "countrySpainForm":
          return countrySpainForm(childitem[currentCase], staticData);
          break;
        case "countryUKDecForm":
          return countryUKDecForm(childitem[currentCase], staticData);
          break;
        case "countryItalyForm":
          return countryItalyForm(childitem[currentCase], staticData);
          break;

        default:
          return '';
      }
    }

    return (
      <div className="gdoc-preview-request-content">
        <span>
          {Translations(pageJson.dynamic_accordion_list_additionalDataRequired.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        </span>
        <NavListAccordionWrapper>
          {additionalDataRequired.length > 0 ? additionalDataRequired.map((item, key) => (
            <NavListAccordion navAccHeading={item.countryFormName} key={key}>
              <div className="basic-details-section">
                {additionalDataMethod(item, staticData)}
              </div>
            </NavListAccordion>
          )
          ) : ""}
        </NavListAccordionWrapper>
      </div>
    )

  }

}

export default AdditionalData;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/AdditionalData.js